<div class="auth-system-container w-100">
  <div class="close-modal" (click)="closeModal()"><span>X</span></div>
  <div class="title">
    {{'Sistema de autenticacion'|translate}}
  </div>
  <div class="label">
    {{'Ingresa la clave aleatoria que muestra el TOKEN'|translate}}
  </div>
  <div class="input-auth">
    <input type="password" class="form-control token-input" [(ngModel)]="token"
           [maxlength]="10" [minlength]="6">
    <span *ngIf="errorToken"
          [ngClass]="{'span-error':errorType!=ValidationTokenErrorEnum.TOKEN_03,'span-message':errorType ==ValidationTokenErrorEnum.TOKEN_03}">
      {{errorMessage}}
    </span>
  </div>
  <div class="send-btn">
    <button class="btn-primary btn-token" type="button" [disabled]="disableBtn()"
            (click)="onValidateToken()">
      <div *ngIf="!systemAuthenticationService.loading" class="enable-btn">
        {{'Enviar'|translate}}
      </div>
      <div *ngIf="systemAuthenticationService.loading" class="loading-btn">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{'Validando'|translate}}...
      </div>
    </button>
  </div>
</div>
